import { api, formatApiErrorDetail } from "@/lib/api";

let scriptPromise = null;

function loadRazorpayScript() {
    if (window.Razorpay) return Promise.resolve(true);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve) => {
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
    return scriptPromise;
}

/**
 * startPayment — creates an order server-side, opens Razorpay Checkout, verifies server-side.
 * payload: { purpose, item, name, email, phone?, application_id? }
 * returns: { ok: boolean, error?: string }
 */
export async function startPayment(payload, { onSuccess, onDismiss, onFailed } = {}) {
    const loaded = await loadRazorpayScript();
    if (!loaded) return { ok: false, error: "Could not load payment gateway. Check your connection." };

    let order;
    try {
        const { data } = await api.post("/payments/create-order", payload);
        order = data;
    } catch (e) {
        return { ok: false, error: formatApiErrorDetail(e?.response?.data?.detail) };
    }

    return new Promise((resolve) => {
        const rzp = new window.Razorpay({
            key: order.key_id,
            amount: order.amount,
            currency: order.currency,
            order_id: order.order_id,
            name: "Z Ed School of Global Impact",
            description: order.label,
            prefill: { name: payload.name, email: payload.email, contact: payload.phone || "" },
            theme: { color: "#C9A24B" },
            handler: async (res) => {
                try {
                    await api.post("/payments/verify", {
                        razorpay_order_id: res.razorpay_order_id,
                        razorpay_payment_id: res.razorpay_payment_id,
                        razorpay_signature: res.razorpay_signature,
                    });
                    if (onSuccess) onSuccess(res);
                    resolve({ ok: true });
                } catch (e) {
                    resolve({ ok: false, error: formatApiErrorDetail(e?.response?.data?.detail) || "Verification failed" });
                }
            },
            modal: {
                ondismiss: () => {
                    if (onDismiss) onDismiss();
                    resolve({ ok: false, dismissed: true });
                },
            },
        });
        rzp.on("payment.failed", (resp) => {
            if (onFailed) {
                try { onFailed(resp); } catch (_e) { /* noop */ }
            }
            resolve({ ok: false, error: resp?.error?.description || "Payment failed" });
        });
        rzp.open();
    });
}
